import { render, staticRenderFns } from "./Alert.vue?vue&type=template&id=ab3d7972"
import script from "./Alert.vue?vue&type=script&lang=js"
export * from "./Alert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports